import styled from 'styled-components'
import { Dropdown } from 'semantic-ui-react'

const CustomDropdown = ({ ...props }) => {
  return <StyledDropdown {...props} />
}

const StyledDropdown = styled(Dropdown)`
  &&& {
    &.ui {
      &.button {
        background-color: white;
        font-weight: 400;
        padding-right: 28px;
        min-width: 130px;
        .icon {
          position: absolute;
          right: 7px;
          margin: 0 !important;
          color: #21ba45;
        }

        &:hover {
          background-color: ${props => props.theme.primaryColor};
          color: ${props => props.theme.secondaryFontColor};
          .icon {
            color: ${props => props.theme.secondaryFontColor};
          }
        }
      }
    }
  }
`
export default CustomDropdown
